export default "__VITE_ASSET__aXhsAG$M__"